import { MAIN_PATH } from 'cpmMyBookings/navigation';

const indexComponent = require('./routes/list/components/MyBookingsList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: MAIN_PATH,
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/show'),
        require('./routes/extend'),
        require('./routes/overstay'),
      ]);
    });
  },
};



// WEBPACK FOOTER //
// ./routes/my_bookings/index.js